import { render, staticRenderFns } from "./ui-number.vue?vue&type=template&id=52da99d6&scoped=true&"
import script from "./ui-number.vue?vue&type=script&lang=js&"
export * from "./ui-number.vue?vue&type=script&lang=js&"
import style0 from "./ui-number.vue?vue&type=style&index=0&id=52da99d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da99d6",
  null
  
)

export default component.exports